'use client'
import {useLocale, useTranslations} from 'next-intl';
import {useState} from 'react';
import {useErrorAlert} from '@/hooks/useSweetAlert';
import {useForm} from 'react-hook-form';
import {zodResolver} from '@hookform/resolvers/zod';
import {z} from 'zod';
import {resetEmailAction} from '@/actions/auth';
import {getGqlErrorToast} from '@/libs/api/errorHandler';
import {ZodValidator} from '@/libs/zod.validator';
import {Link} from "@/i18n/routing";
import {CALLBACK_URL_PARAM, LOGIN_ROUTE_NAME, PRIVATE_ROUTE_NAME} from '@/libs/constants/common.constants';
import {useSearchParams} from 'next/navigation';

export default function ForgotPasswordPrimary({ setEmail, nextTick }) {
  const e = useTranslations('error.message');
  const v = useTranslations('validators');
  const t = useTranslations('auth');
  
  const query = useSearchParams();
  const callbackUrl = query.get(CALLBACK_URL_PARAM) ?? PRIVATE_ROUTE_NAME;

  const [loading, setLoading] = useState(false);
  const errorToast = useErrorAlert();
  const locale = useLocale();
  
  const {
    register,
    handleSubmit,
    formState: { errors, isSubmitting }
  } = useForm({
    resolver: zodResolver(
        z.object({
          email: ZodValidator.email(v, 3),
        })
    ),
    defaultValues: {
      email: '',
    }
  });
  
  const onResetEmail = async (data) => {
    setLoading(true);
    const result = await resetEmailAction({
      email: data.email,
      locale
    });
    if (result.error) {
      errorToast(getGqlErrorToast(result.error.errors, e));
      setLoading(false);
      return;
    }
    if (result.data) {
      setEmail(data.email);
      nextTick();
      setLoading(false);
    }
  };
  
  return (
    <div className="ltn__login-area" style={{minHeight: '70vh', alignContent: 'center'}}>
      <div className="container">
        <div className="row">
          <div className="col-lg-12">
            <div className="section-title-area text-center">
              <h1 className="section-title">
                {t('forgotPasswordTitle')}
              </h1>
              <p>
                {t('forgotPasswordDescription')}
              </p>
            </div>
          </div>
        </div>
        <div className="row">
          <div className="col-lg-6 offset-lg-3">
            <div className="account-login-inner">
              <form onSubmit={handleSubmit(onResetEmail)} className="ltn__form-box contact-form-box">
                <div className={`form-group ${errors.email ? 'has-error' : ''}`}>
                  <input
                      id="email"
                      type="email"
                      placeholder={`${t('email')}*`}
                      {...register('email')}
                  />
                  {errors.email && <span className="error-message">{errors.email.message}</span>}
                </div>
                <div className="btn-wrapper">
                  <button
                      className="theme-btn-1 btn reverse-color btn-block text-uppercase"
                      type="submit"
                      disabled={loading || isSubmitting}
                  >
                    {isSubmitting || loading ? t('resetting') : t('resetPassword')}
                  </button>
                </div>
                <div className="go-to-btn mt-20 text-center text-uppercase">
                  <Link href={`${LOGIN_ROUTE_NAME}?${CALLBACK_URL_PARAM}=${callbackUrl}`}>
                    <small>{t('rememberedPassword')}</small>
                  </Link>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
